<template>
  <div class="reputation-list">
    <ul>
      <li>
        <div class="item-content">
          <ym-avatar class="user-avatar"
                     :avatar="require('@/assets/img/reputation/avatar1.png')"
          />

          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">Michael Barry</div>
            </div>

            <div class="item-subtitle">美国斯坦福大学教授 Point Forward创办人</div>
            <div class="item-subcontent">设计思维应该从小开始培养。少年商学院让孩子们拥有了改变世界的力量。</div>
          </div>
        </div>
      </li>
      <li>
        <div class="item-content">
          <ym-avatar class="user-avatar"
                     :avatar="require('@/assets/img/reputation/avatar2.png')"
          />

          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">Ulrich Weinberg</div>
            </div>

            <div class="item-subtitle">德国波茨坦大学教授 d.school创办人</div>
            <div class="item-subcontent">翻转课堂让老师学生双赢，期待少年商学院的努力使中国少年成为地球上最具同理心的一代。</div>
          </div>
        </div>
      </li>
      <li>
        <div class="item-content">
          <ym-avatar class="user-avatar"
                     :avatar="require('@/assets/img/reputation/avatar3.png')"
          />

          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">Jeffrey Ho</div>
            </div>

            <div class="item-subtitle">新加坡国家设计中心 Design Singapore理事长</div>
            <div class="item-subcontent">未来的医生、工程师、科学家都需要懂得运用设计思维。我很欣慰少年商学院如此重视设计思维。</div>
          </div>
        </div>
      </li>
      <li>
        <div class="item-content">
          <ym-avatar class="user-avatar"
                     :avatar="require('@/assets/img/reputation/avatar4.png')"
          />

          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">Debbie Hung</div>
            </div>

            <div class="item-subtitle">前沃顿招生官 少年商学院特约嘉宾</div>
            <div class="item-subcontent">美国学校非常关注善于从身边学习知识与技能的孩子。少年商学院做的事情非常有价值。</div>
          </div>
        </div>
      </li>
      <li>
        <div class="item-content">
          <ym-avatar class="user-avatar"
                     :avatar="require('@/assets/img/reputation/avatar5.png')"
          />

          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">Matthew Straub</div>
            </div>

            <div class="item-subtitle">CityX Project 联合创始人</div>
            <div class="item-subcontent">我们将City X项目独家授权少年商学院在中国开展，相信3D打印等新技术孩子们能熟练运用。</div>
          </div>
        </div>
      </li>
      <li>
        <div class="item-content">
          <ym-avatar class="user-avatar"
                     :avatar="require('@/assets/img/reputation/avatar6.png')"
          />

          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">尹建莉</div>
            </div>

            <div class="item-subtitle">著名家庭教育专家 超级畅销书《好妈妈胜过好老师》作者</div>
            <div class="item-subcontent">我很欣赏少年商学院“敢让孩子做自己”的理念与倡导。爱孩子，就给他自由，让他快乐。</div>
          </div>
        </div>
      </li>
      <li>
        <div class="item-content">
          <ym-avatar class="user-avatar"
                     :avatar="require('@/assets/img/reputation/avatar7.png')"
          />

          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">吴晓波</div>
            </div>

            <div class="item-subtitle">知名财经作家</div>
            <div class="item-subcontent">从小启发孩子的商业思维与领导力非常重要，祝少年商学院像少年一样健康成长。</div>
          </div>
        </div>
      </li>
      <li>
        <div class="item-content">
          <ym-avatar class="user-avatar"
                     :avatar="require('@/assets/img/reputation/avatar8.png')"
          />

          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">罗振宇</div>
            </div>

            <div class="item-subtitle">“罗辑思维”创始人</div>
            <div class="item-subcontent">少年商学院在学校、社会、家长之间搭建了一个高效协作社群，我看好少年商学院！</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar';

  export default {
    name: 'ReputationList',
    components: {
      'ym-avatar': Avatar,
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .reputation-list {
    margin: 0;
    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }
    li {
      background: @color-white;
      border-bottom: @border-base;
      padding: 20px;
    }
  }

  .item-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .item-media {
    align-self: stretch;
    align-items: flex-start;
    padding: 0;
  }
  .item-inner {
    margin-left: 16px;
    padding: 0;
    align-self: stretch;
  }
  .item-title {
    font-size: @font-size-base;
  }
  .item-subtitle {
    font-size: @font-size-small;
    overflow: auto;
    white-space: pre-wrap;
    color: @color-text-light;
  }
  .item-subcontent {
    font-size: @font-size-small;
    overflow: auto;
    white-space: pre-wrap;
  }

</style>
